(function (w, d, s, o, f, js, fjs) {
  w["Avease-Widget"] = o;
  w[o] =
    w[o] ||
    function () {
      (w[o].q = w[o].q || []).push(arguments);
    };
  (js = d.createElement(s)), (fjs = d.getElementsByTagName(s)[0]);
  js.id = o;
  js.src = f;
  js.async = 1;
  fjs.parentNode.insertBefore(js, fjs);
})(
  window,
  document,
  "script",
  "av",
   "https://widget.avease.ai/assets/snippet.js"
);
av("config", {
  id: "0c00c534-8475-441f-b56b-56834a14a512"
});
av("init");